import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';
import PublicPageLayout from './PublicPageLayout';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [error, setError] = useState('');

  const { verifyEmail, resendVerificationCode } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await verifyEmail(email, code);

    if (result.success) {
      toast.success(result.message || 'Email verified successfully.');
      navigate('/login');
    } else {
      setError(result.error);
      toast.error('Verification failed');
    }

    setLoading(false);
  };

  const handleResend = async () => {
    if (!email) {
      setError('Enter your email first');
      return;
    }
    setResending(true);
    setError('');

    const result = await resendVerificationCode(email);
    toast.success(result.message || 'If your account needs verification, a new code has been sent.');

    setResending(false);
  };

  return (
    <PublicPageLayout subtitle="Verify your email">
      {error && <Alert variant="danger">{error}</Alert>}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your account email"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Verification code</Form.Label>
          <Form.Control
            type="text"
            name="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
            placeholder="6-digit code"
            maxLength={6}
          />
          <Form.Text className="text-muted">
            We emailed a 6-digit code when you registered. It expires 10 minutes after it was sent.
          </Form.Text>
        </Form.Group>

        <Button
          variant="primary"
          type="submit"
          className="w-100"
          disabled={loading}
        >
          {loading ? 'Verifying...' : 'Verify email'}
        </Button>

        <div className="text-center mt-3">
          <Button variant="link" className="p-0" onClick={handleResend} disabled={resending}>
            {resending ? 'Sending...' : "Didn't get a code? Resend"}
          </Button>
        </div>

        <div className="text-center mt-3">
          <Link to="/login">Back to sign in</Link>
        </div>
      </Form>
    </PublicPageLayout>
  );
}

export default VerifyEmail;
